import conftemp from "../Docs/conference-template-a4.docx";
import conftempLetter from "../Docs/conference-template-letter.docx";
import latexInst from "../Docs/IEEEtran_HOWTO.pdf";
import latex from "../Docs/conference-latex-template_10-17-19.zip";
import Elsevier from "../Docs/Elsevier SSRN_Word Template.docx";
import bib from "../Docs/IEEEtranBST2.zip";
import spsess from "../Docs/Special_Session_ICCRDA.docx";
import ElsevierPPT from "../Docs/ICCTRDA_2025_PPT_Template_Elsevier.pptx";
import ElsevierPDF from "../Docs/ICCTRDA_2025_PPT_Template_Elsevier.pdf";
import springerWord from "../Docs/Springer DOC.zip";
import springerLatex from "../Docs/Springer LaTeX Template.zip";
import paperPresentation from "../Docs/Paper Presentation Schedule_ICCTRDA 2025_Springer.pdf";
import license from "../Docs/ltp_2025.docx";
import springerPPT from "../Docs/ICCTRDA_2026_PPT_Template_Springer.pptx";
import springerPDF from "../Docs/ICCTRDA_2026_PPT_Template_Springer.pdf";
import adroidPPT from "../Docs/ICCTRDA_2026_PPT_Template_Adroid.pptx";
import adroidPDF from "../Docs/ICCTRDA_2026_PPT_Template_Adroid.pdf";
import springerProceedingsPapers from "../Docs/SpringerProceedingsPaper.docx";

export const downloadFiles = [
  // { name: "Conference Template - A4", file: conftemp },
  // { name: "US Letter", file: conftempLetter },
  { name: "LaTeX Template Instructions", file: latexInst },
  { name: "LaTeX Template", file: latex },
  { name: "LaTeX Bibliography Files", file: bib },
{ name: "Springer Proceedings Papers", file: springerProceedingsPapers },
  // { name: "Elsevier SSRN Paper Template PPT", file: ElsevierPPT },
  // { name: "Elsevier SSRN Paper Template PDF", file: ElsevierPDF },
  { name: "Springer Word Template", file: springerWord },
   { name: "Springer PPT Template", file: springerPPT },
   { name: "Springer PPT Template PDF", file: springerPDF },
{ name: "ICCTRDA 2026 Adroid PPT Template(PDF)", file: adroidPDF },
{ name: "ICCTRDA 2026 Adroid PPT Template", file: adroidPPT },

  { name: "Springer LaTex Template", file: springerLatex },
  // { name: "Licence to Publish form", file: license },
  // { name: "ICCTRDA-2026 Paper Presentation Schedule", file: paperPresentation },
  // { name: "Special Session Proposal Template", file: spsess },
];
